(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cgl-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cgl-product-reviews')) return;

    class CglProductReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        const start = () => this.initialize();
        if (!('IntersectionObserver' in window) || Shopify.designMode) {
          start();
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          start();
        }, { rootMargin: '500px 0px' });

        observer.observe(this);
      }

      initialize() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const data = this.readStructuredData() || this.readLegacyData();
        if (!data || !data.count) {
          this.hidden = true;
          return;
        }

        this.renderSummary(data);
        this.renderMedia(data);
        this.renderReviews(data);
      }

      readStructuredData() {
        const script = this.querySelector('[data-cgl-review-json]');
        if (!script || !script.textContent.trim()) return null;

        try {
          const source = JSON.parse(script.textContent);
          return this.normalize({
            average: source.average_rating,
            count: source.number_of_reviews,
            histogram: source.histogram,
            reviews: source.reviews,
            gallery: source.photo_gallery
          });
        } catch (error) {
          return null;
        }
      }

      readLegacyData() {
        const template = this.querySelector('[data-cgl-review-legacy]');
        if (!template) return null;

        const fragment = template.content.cloneNode(true);
        const widget = fragment.querySelector('.jdgm-rev-widg');
        if (!widget) return null;

        const reviews = [...fragment.querySelectorAll('.jdgm-rev')].map((review) => {
          const pictures = [...review.querySelectorAll('.jdgm-rev__pic-link')].map((link) => ({
            original: link.getAttribute('href'),
            compact: link.querySelector('img')?.dataset.src || link.getAttribute('href')
          }));

          return {
            uuid: review.dataset.reviewId,
            rating: review.querySelector('.jdgm-rev__rating')?.dataset.score,
            title: review.querySelector('.jdgm-rev__title')?.textContent,
            body: review.querySelector('.jdgm-rev__body')?.textContent,
            body_html: review.querySelector('.jdgm-rev__body')?.innerHTML,
            reviewer_name: review.querySelector('.jdgm-rev__author')?.textContent,
            location: review.querySelector('.jdgm-rev__location')?.textContent,
            verified_buyer: review.dataset.verifiedBuyer === 'true',
            created_at: review.querySelector('time')?.getAttribute('datetime') || review.querySelector('time')?.dataset.content,
            pictures_urls: pictures
          };
        });

        let gallery = [];
        const galleryElement = fragment.querySelector('.jdgm-gallery-data[data-json]');
        if (galleryElement) {
          try {
            gallery = JSON.parse(galleryElement.dataset.json || '[]');
          } catch (error) {
            gallery = [];
          }
        }

        const histogram = [...fragment.querySelectorAll('.jdgm-histogram__row[data-rating]')].map((row) => ({
          rating: row.dataset.rating,
          frequency: row.dataset.frequency,
          percentage: row.dataset.percentage
        }));

        return this.normalize({
          average: widget.dataset.averageRating,
          count: widget.dataset.numberOfReviews,
          histogram,
          reviews,
          gallery
        });
      }

      normalize(source) {
        const reviews = Array.isArray(source.reviews) ? source.reviews : [];
        const gallery = Array.isArray(source.gallery) ? source.gallery : [];
        const merged = [];
        const seen = new Set();

        [...reviews, ...gallery].forEach((review) => {
          const key = review.uuid || `${review.reviewer_name}-${review.created_at}-${review.title}`;
          if (!key || seen.has(key)) return;
          seen.add(key);
          merged.push(review);
        });

        return {
          average: Number(source.average) || 0,
          count: Number(source.count) || 0,
          histogram: Array.isArray(source.histogram) ? source.histogram : [],
          reviews: merged.slice(0, 10),
          gallery
        };
      }

      renderSummary(data) {
        const summary = this.querySelector('[data-cgl-summary]');
        const label = data.count === 1 ? this.dataset.reviewSingular : this.dataset.reviewPlural;
        const histogram = data.histogram
          .filter((item) => Number(item.rating) > 0)
          .sort((a, b) => Number(b.rating) - Number(a.rating));

        summary.replaceChildren();

        const score = document.createElement('div');
        score.className = 'cgl-reviews__score';

        const number = document.createElement('strong');
        number.className = 'cgl-reviews__score-number';
        number.textContent = data.average.toFixed(1);

        const stars = this.makeAverageStars(data.average, `${data.average.toFixed(1)} out of 5 stars`);

        const count = document.createElement('span');
        count.className = 'cgl-reviews__score-count';
        count.textContent = `Based on ${data.count.toLocaleString()} ${label}`;

        score.append(number, stars, count);
        summary.append(score);

        if (!histogram.length) return;

        const histogramElement = document.createElement('div');
        histogramElement.className = 'cgl-reviews__histogram';
        histogramElement.setAttribute('aria-label', 'Rating distribution');

        histogram.forEach((item) => {
          const percentage = Math.max(0, Math.min(100, Number(item.percentage) || 0));
          const row = document.createElement('div');
          row.className = 'cgl-reviews__histogram-row';

          const rating = document.createElement('span');
          rating.textContent = `${item.rating} star`;

          const bar = document.createElement('span');
          bar.className = 'cgl-reviews__bar';
          const fill = document.createElement('span');
          fill.style.setProperty('--bar-width', `${percentage}%`);
          bar.append(fill);

          const frequency = document.createElement('span');
          frequency.textContent = Number(item.frequency || 0).toLocaleString();

          row.append(rating, bar, frequency);
          histogramElement.append(row);
        });

        summary.append(histogramElement);
      }

      renderMedia(data) {
        const mediaSection = this.querySelector('[data-cgl-media]');
        const rail = this.querySelector('[data-cgl-media-rail]');
        const mediaReviews = [...data.gallery, ...data.reviews]
          .filter((review) => Array.isArray(review.pictures_urls) && review.pictures_urls.length)
          .filter((review, index, array) => {
            const url = review.pictures_urls[0]?.original || review.pictures_urls[0]?.compact;
            return url && array.findIndex((item) => {
              const itemUrl = item.pictures_urls?.[0]?.original || item.pictures_urls?.[0]?.compact;
              return itemUrl === url;
            }) === index;
          })
          .slice(0, 10);

        if (!mediaReviews.length) return;

        const fragment = document.createDocumentFragment();
        mediaReviews.forEach((review) => {
          const picture = review.pictures_urls[0];
          const compact = this.safeUrl(picture.compact || picture.original);
          const original = this.safeUrl(picture.original || picture.compact);
          if (!compact || !original) return;

          const link = document.createElement('a');
          link.className = 'cgl-reviews__media-link';
          link.href = original;
          link.target = '_blank';
          link.rel = 'nofollow noopener';
          link.setAttribute('aria-label', `Open review photo from ${review.reviewer_name || 'a customer'}`);

          const image = document.createElement('img');
          image.src = compact;
          image.alt = `Customer review from ${review.reviewer_name || 'a verified buyer'}`;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 170;
          image.height = 170;

          link.append(image);
          fragment.append(link);
        });

        if (!fragment.childNodes.length) return;
        rail.append(fragment);
        mediaSection.hidden = false;
      }

      renderReviews(data) {
        const list = this.querySelector('[data-cgl-list]');
        const actions = this.querySelector('[data-cgl-actions]');
        const more = this.querySelector('[data-cgl-more]');
        const initialCount = Math.max(3, Math.min(10, Number(this.dataset.initialCount) || 6));

        const fragment = document.createDocumentFragment();
        data.reviews.forEach((review, index) => {
          const card = this.makeReviewCard(review);
          if (!card) return;
          if (index >= initialCount) card.hidden = true;
          fragment.append(card);
        });

        list.append(fragment);
        const hiddenCards = [...list.querySelectorAll('.cgl-review-card[hidden]')];
        const writeLink = actions.querySelector('.cgl-reviews__write');

        if (hiddenCards.length) {
          more.textContent = this.dataset.showMore;
          more.addEventListener('click', () => {
            const expanding = hiddenCards.some((card) => card.hidden);
            hiddenCards.forEach((card) => { card.hidden = !expanding; });
            more.textContent = expanding ? this.dataset.showLess : this.dataset.showMore;
            more.setAttribute('aria-expanded', String(expanding));
          });
        } else {
          more.hidden = true;
        }

        actions.hidden = more.hidden && !writeLink;
      }

      makeReviewCard(review) {
        const body = this.cleanText(review.body || review.body_html);
        const title = this.cleanText(review.title);
        if (!body && !title) return null;

        const card = document.createElement('article');
        card.className = 'cgl-review-card';

        const top = document.createElement('div');
        top.className = 'cgl-review-card__top';
        top.append(this.makeReviewStars(review.rating));

        const date = document.createElement('time');
        date.className = 'cgl-review-card__date';
        const parsedDate = this.parseDate(review.created_at);
        if (parsedDate) {
          date.dateTime = parsedDate.toISOString();
          date.textContent = new Intl.DateTimeFormat(undefined, { month: 'short', year: 'numeric' }).format(parsedDate);
        }
        top.append(date);
        card.append(top);

        if (title) {
          const heading = document.createElement('h3');
          heading.className = 'cgl-review-card__title';
          heading.textContent = title;
          card.append(heading);
        }

        if (body && body !== title) {
          const paragraph = document.createElement('p');
          paragraph.className = 'cgl-review-card__body';
          paragraph.textContent = body;
          card.append(paragraph);
        }

        const picture = review.pictures_urls?.[0];
        if (picture) {
          const compact = this.safeUrl(picture.compact || picture.original);
          const original = this.safeUrl(picture.original || picture.compact);
          if (compact && original) {
            const link = document.createElement('a');
            link.className = 'cgl-review-card__photo';
            link.href = original;
            link.target = '_blank';
            link.rel = 'nofollow noopener';

            const image = document.createElement('img');
            image.src = compact;
            image.alt = `Review photo from ${review.reviewer_name || 'a customer'}`;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 88;
            image.height = 88;
            link.append(image);
            card.append(link);
          }
        }

        const authorRow = document.createElement('div');
        authorRow.className = 'cgl-review-card__author-row';

        const author = document.createElement('span');
        author.className = 'cgl-review-card__author';
        author.textContent = this.cleanText(review.reviewer_name) || 'Anonymous';
        authorRow.append(author);

        if (review.verified_buyer === true || String(review.verified_buyer) === 'true') {
          const verified = document.createElement('span');
          verified.className = 'cgl-review-card__verified';
          verified.textContent = this.dataset.verifiedLabel;
          authorRow.append(verified);
        }

        const locationText = this.cleanText(review.location);
        if (locationText) {
          const location = document.createElement('span');
          location.className = 'cgl-review-card__location';
          location.textContent = locationText;
          authorRow.append(location);
        }

        card.append(authorRow);
        return card;
      }

      makeAverageStars(rating, label) {
        const stars = document.createElement('span');
        stars.className = 'cgl-reviews__stars';
        stars.textContent = '★★★★★';
        stars.style.setProperty('--fill', `${Math.max(0, Math.min(100, rating / 5 * 100))}%`);
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', label);
        return stars;
      }

      makeReviewStars(rating) {
        const score = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
        const stars = document.createElement('span');
        stars.className = 'cgl-review-card__stars';
        stars.textContent = `${'★'.repeat(score)}${'☆'.repeat(5 - score)}`;
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${score} out of 5 stars`);
        return stars;
      }

      cleanText(value) {
        if (!value) return '';
        const element = document.createElement('div');
        element.innerHTML = String(value);
        return element.textContent.replace(/\s+/g, ' ').trim();
      }

      safeUrl(value) {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.origin);
          return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
        } catch (error) {
          return '';
        }
      }

      parseDate(value) {
        if (!value) return null;
        const normalized = String(value).replace(' UTC', 'Z').replace(' ', 'T');
        const date = new Date(normalized);
        return Number.isNaN(date.getTime()) ? null : date;
      }
    }

    customElements.define('cgl-product-reviews', CglProductReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  class HotspotSection {
    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('[data-hotspot-trigger]');
      this.cards = container.querySelectorAll('[data-hotspot-card]');
      this.closeBtns = container.querySelectorAll('[data-hotspot-close]');
      this.init();
    }

    init() {
      this.buttons.forEach(btn => btn.addEventListener('click', (e) => this.toggleCard(e)));
      this.closeBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); this.closeAll(); }));
      document.addEventListener('click', (e) => { if (!this.container.contains(e.target)) this.closeAll(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
      
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.closeAll(), 250);
      });
    }

    toggleCard(e) {
      if (e.target.closest('.hotspot-card')) return;
      e.preventDefault(); e.stopPropagation();

      const btn = e.currentTarget;
      const wrapper = btn.closest('.hotspot-item');
      const card = wrapper.querySelector('[data-hotspot-card]');
      if (!card) return;

      const isOpening = card.hidden || card.getAttribute('aria-hidden') === 'true';
      this.closeAll();

      if (isOpening) {
        card.hidden = false;
        this.smartPosition(card, wrapper);
        requestAnimationFrame(() => {
          card.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        });
      }
    }

    smartPosition(card) {
        const currentClasses = Array.from(card.classList);
        const directionClass = currentClasses.find(c => c.startsWith('hotspot-card--'));
        let currentDir = directionClass ? directionClass.replace('hotspot-card--', '') : 'top-right';

        card.style.transform = '';
        const cardRect = card.getBoundingClientRect();
        const viewportW = window.innerWidth;
        const viewportH = window.innerHeight;
        let newDir = currentDir;
        
        if (cardRect.right > viewportW) newDir = newDir.replace('right', 'left');
        else if (cardRect.left < 0) newDir = newDir.replace('left', 'right');

        const headerHeight = 80; 
        if (cardRect.bottom > viewportH) newDir = newDir.replace('bottom', 'top');
        else if (cardRect.top < headerHeight) newDir = newDir.replace('top', 'bottom');

        if (newDir !== currentDir) {
            card.classList.remove(`hotspot-card--${currentDir}`);
            card.classList.add(`hotspot-card--${newDir}`);
        }
        
        // Final nudge
        const finalRect = card.getBoundingClientRect();
        const margin = 15;
        let nudgeX = 0;
        if (finalRect.right > (viewportW - margin)) nudgeX = (viewportW - margin) - finalRect.right;
        else if (finalRect.left < margin) nudgeX = margin - finalRect.left;

        if (nudgeX !== 0) card.style.transform = `translateX(${nudgeX}px)`;
    }

    closeAll() {
      this.cards.forEach(card => {
        card.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          if (card.getAttribute('aria-hidden') === 'true') {
             card.hidden = true;
             card.style.transform = ''; 
          }
        }, 250);
      });
      this.buttons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hotspot-wrapper').forEach(el => new HotspotSection(el));
  });
  
  document.addEventListener('shopify:section:load', (e) => {
    const wrapper = e.target.querySelector('.hotspot-wrapper');
    if(wrapper) new HotspotSection(wrapper);
  });

  } catch(e) { console.error(e); }
})();
})();
